var render = function render(){var _vm=this,_c=_vm._self._c;return _c('submenu',{attrs:{"dropdown-class":"mt-md","placement":"bottom-end"}},[_c('div',{staticClass:"flex items-center cursor-pointer action-button"},[_c('font-awesome-icon',{staticClass:"text-xs",attrs:{"icon":"cog"}})],1),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"list"},[_vm._t("default")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }